<div class="wrap">
  <div class="header">
    <div class="logo">
      <app-svg-icon
        [name]="'logo-small'"
        [color]="'color-surface'"
      ></app-svg-icon>
    </div>
    <div class="greeting">{{ "@pages.login.greeting" | translate }}</div>
    <div class="brand">Chill&Bite</div>
  </div>
  <div class="content">
    <div class="title">{{ "@pages.login.title" | translate }}</div>
    <div class="form">
      <div class="form-item">
        <app-input
          [control]="loginForm.controls.email"
          [iconName]="'email'"
          [label]="'@pages.login.form.email.label' | translate"
          [placeholder]="'@pages.login.form.email.placeholder' | translate"
          [inputType]="'email'"
        ></app-input>
        <div
          *ngIf="
            loginForm.controls.email.touched && !loginForm.controls.email.value
          "
          class="input-error-message"
        >
          {{ "@pages.login.form.errors.emailEmpty" | translate }}
        </div>
        <div
          *ngIf="
            loginForm.controls.email.touched &&
            loginForm.controls.email.value &&
            loginForm.controls.email.invalid
          "
          class="input-error-message"
        >
          {{ "@pages.login.form.errors.emailInvalid" | translate }}
        </div>
      </div>
      <div class="form-item">
        <app-input
          [control]="loginForm.controls.password"
          [iconName]="'lock'"
          [label]="'@pages.login.form.password.label' | translate"
          [placeholder]="'@pages.login.form.password.placeholder' | translate"
          [inputType]="'password'"
        ></app-input>
        <div
          *ngIf="
            loginForm.controls.password.touched &&
            !loginForm.controls.password.value
          "
          class="input-error-message"
        >
          {{ "@pages.login.form.errors.passwordEmpty" | translate }}
        </div>
      </div>
      <div class="language-selector">
        <app-language-selector></app-language-selector>
      </div>
      <div
        *ngIf="showWrongCredentialsMessage"
        class="wrong-credentials-message"
      >
        {{ "@pages.login.form.errors.wrongCredentials" | translate }}
      </div>
    </div>
    <div (click)="onForgotPasswordClick()" class="forgot-password">
      {{ "@pages.login.forgotPassword" | translate }}
    </div>
    <div class="action-btn">
      <app-action-button
        (click)="onLoginButtonClick()"
        [label]="'@pages.login.actionBtn' | translate"
        [endIconName]="'arrow-right'"
        [disabled]="loginForm.invalid || loginForm.untouched"
        [isLoading]="(loader.isLoading$ | async)!"
      ></app-action-button>
    </div>
    <div (click)="onDontHaveAccountClick()" class="link">
      {{ "@pages.login.dontHaveAccount" | translate }}
    </div>
    <div (click)="onOpenPolicyLink()" class="link">
      {{ "@pages.login.policyLink" | translate }}
    </div>
    <div (click)="onOpenTermsOfUseLink()" class="link">
      {{ "@pages.login.termsOfUseLink" | translate }}
    </div>
    <div (click)="onOpenImprintLink()" class="link">
      {{ "@pages.login.imprintLink" | translate }}
    </div>
  </div>
</div>
